<div [formGroup]="form">
  <mat-form-field>
    <input
      matInput
      formControlName="appointment_time"
      name="appointment_time"
      type="text"
      placeholder="Appointment time"
      i18n-placeholder="@@formLabelAppointmentTime"
    />
    <mat-hint align="start">hh:mm (am/pm)</mat-hint>
    <mat-error *ngIf="form.get('appointment_time').errors">
      Format is not valid. Example: 2:45 pm
    </mat-error>
  </mat-form-field>
</div>
